export default "__VITE_ASSET__DsnKG5nj__"